export default { sha: '1853c179663befc798e8c6501f8a1108efcc290a', buildNumber: 'undefined' }
